module.exports = __webpack_public_path__ + "static/media/logout2.e1df52e2.svg";